import { render, staticRenderFns } from "./BAutocompleteProcedureMarks.vue?vue&type=template&id=13047a40&"
import script from "./BAutocompleteProcedureMarks.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteProcedureMarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports